module.exports = __webpack_public_path__ + "static/media/WeChat.9e9fbe5b.svg";